import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { borderRadiusFull, borderWidth2, colorIconError, colorIconOnPrimary, space05, space2 } = theme();

  return StyleSheet.create({
    badge: {
      backgroundColor: colorIconError,
      borderColor: colorIconOnPrimary,
      borderRadius: borderRadiusFull,
      borderWidth: borderWidth2,
      height: space2 + space05,
      position: "absolute",
      right: space2,
      top: space2,
      width: space2 + space05,
    },
  });
};

export { style };
